import styled from "styled-components";

export const MapContainer = styled.section`
    width: 100%;
    padding: 16px;
`;

export const MapHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 16px;
`;

export const MapTitle = styled.h2`
    margin: 0;
    color: #1f2937;
    font-size: 24px;
`;

export const FilterContainer = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
`;

export const FilterGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 150px;
`;

export const FilterLabel = styled.label`
    color: #374151;
    font-size: 13px;
    font-weight: 600;
`;

export const FilterSelect = styled.select`
    min-height: 38px;
    padding: 7px 10px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    background-color: white;
    color: #111827;
    font-size: 14px;
    outline: none;

    &:focus {
        border-color: #64748b;
        box-shadow: 0 0 0 2px
            rgba(100, 116, 139, 0.15);
    }
`;

export const LegendContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
    padding: 10px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    background-color: #f9fafb;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    color: #374151;
    font-size: 13px;
    font-weight: 500;
`;

export const LegendColor = styled.span`
    width: 18px;
    height: 18px;
    border: 1px solid #6b7280;
    border-radius: 3px;
    background-color: ${({ $color }) =>
        $color};
`;

export const StatisticsContainer = styled.div`
    display: grid;
    grid-template-columns:
        repeat(6, minmax(130px, 1fr));
    gap: 10px;

    @media (max-width: 768px) {
        grid-template-columns:
            repeat(2, minmax(120px, 1fr));
    }
`;

export const StatisticItem = styled.div`
    padding: 10px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    background-color: white;

    small {
        display: block;
        margin-top: 4px;
        color: #6b7280;
        font-size: 11px;
    }
`;

export const StatisticLabel = styled.div`
    margin-bottom: 4px;
    color: #6b7280;
    font-size: 12px;
`;

export const StatisticValue = styled.div`
    color: #111827;
    font-size: 19px;
    font-weight: 700;
`;

export const LoadingMessage = styled.div`
    padding: 14px;
    color: #374151;
    text-align: center;
`;

export const ErrorMessage = styled.div`
    padding: 12px;
    border: 1px solid #fca5a5;
    border-radius: 6px;
    background-color: #fef2f2;
    color: #fca5a5;
`;

export const PopupContent = styled.div`
    min-width: 230px;
    padding: 4px;
`;

export const PopupTitle = styled.h3`
    margin: 0 0 10px;
    color: #111827;
    font-size: 16px;
`;

export const PopupRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 4px 0;
    color: #374151;
    font-size: 13px;
`;

export const PopupLabel = styled.span`
    color: #111827;
    font-weight: 600;
`;

export const MapWrapper = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 12px;

    .maplibregl-popup {
        z-index: 20;
    }

    .maplibregl-popup-content {
        padding: 12px;
        border-radius: 9px;
        box-shadow:
            0 8px 24px
            rgba(15, 23, 42, 0.22);
    }

    .maplibregl-popup-close-button {
        padding: 5px 8px;
        color: #374151;
        font-size: 18px;
    }
`;

export const FloatingLegend = styled.div`
    position: absolute;
    z-index: 5;
    left: 16px;
    bottom: 20px;

    display: flex;
    flex-direction: column;
    gap: 8px;

    min-width: 190px;
    padding: 12px 14px;

    border: 1px solid
        rgba(255, 255, 255, 0.7);
    border-radius: 10px;

    background-color:
        rgba(255, 255, 255, 0.92);

    box-shadow: 0 4px 14px
        rgba(15, 23, 42, 0.2);

    backdrop-filter: blur(5px);
`;

export const LegendTitle = styled.strong`
    margin-bottom: 2px;
    color: #111827;
    font-size: 14px;
`;

export const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    width: fit-content;

    padding: 10px 16px;

    border: none;
    border-radius: 10px;

    background: #111827;
    color: #ffffff;

    font-size: 14px;
    font-weight: 600;

    cursor: pointer;

    transition:
        background 0.2s ease,
        transform 0.2s ease,
        box-shadow 0.2s ease;

    box-shadow: 0 6px 14px rgba(17, 24, 39, 0.18);

    svg {
        font-size: 14px;
    }

    &:hover {
        background: #1f2937;
        transform: translateY(-1px);
        box-shadow: 0 8px 18px rgba(17, 24, 39, 0.24);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 4px 10px rgba(17, 24, 39, 0.18);
    }
`;

export const PopupSection = styled.div`
    margin-top: 11px;
`;

export const PopupSectionTitle = styled.div`
    font-size: 11px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 6px;
`;

export const PopupTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
    margin-top: 2px;

    th {
        background: #f3f4f6;
        color: #374151;
        font-weight: 700;
        padding: 2px 3px;
        border: 1px solid #e5e7eb;
        text-align: left;
    }

    td {
        padding: 2px 3px;
        border: 1px solid #e5e7eb;
        color: #374151;
        vertical-align: top;
    }

    tbody tr:nth-child(even) {
        background: #f9fafb;
    }
`;